import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IManagementAction } from './IManagementAction';

@Injectable({
  providedIn: 'root'
})
export class ManagementActionService {
  private ManagementActionRespSubject = new BehaviorSubject<any | null>(null);
  managementActionResp$ = this.ManagementActionRespSubject.asObservable();

  setManagementActionResponse(resp: any ) {
    this.ManagementActionRespSubject.next(resp);
  }
}